var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 12C11.4107 12 12 11.4375 12 10.7143V1.28571C12 0.589286 11.4107 0 10.7143 0H1.28571C0.5625 0 0 0.589286 0 1.28571V10.7143C0 11.4375 0.5625 12 1.28571 12H10.7143ZM5.22321 9.375C5.0625 9.5625 4.76786 9.5625 4.60714 9.375L1.82143 6.58929C1.66071 6.42857 1.66071 6.16071 1.82143 6L2.4375 5.38393C2.59821 5.22321 2.86607 5.22321 3.02679 5.38393L4.92857 7.25893L8.94643 3.24107C9.10714 3.08036 9.375 3.08036 9.53571 3.24107L10.1518 3.85714C10.3125 4.01786 10.3125 4.28571 10.1518 4.44643L5.22321 9.375Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.73248f552e8a27547213a00898c67978.svg";
export { ForwardRef as ReactComponent };